module.exports = __webpack_public_path__ + "static/img/5en.215f5a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/5en.png
// module id = rHLH
// module chunks = 0